
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sports/cricket/india-tour-of-england-2025/schedule",
      function () {
        return require("private-next-pages/sports/cricket/india-tour-of-england-2025/schedule.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sports/cricket/india-tour-of-england-2025/schedule"])
      });
    }
  